import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updatePostType, orgInitialState } from 'redux/modules/groupPostCompose';
import { ButtonBar } from 'components';
import { GLinkPostSection, GImagePostSection, GVideoPostSection } from 'components/GroupPost';
import * as styles from './Group.scss';
var GPostTypeArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id
  };
}, {
  updatePostType: updatePostType
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GPostTypeArea, _Component);

  var _super = _createSuper(GPostTypeArea);

  function GPostTypeArea() {
    var _this;

    _classCallCheck(this, GPostTypeArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handlePostTypeChange", function (tab) {
      var organizationId = _this.props.organizationId;

      _this.props.updatePostType(tab.key, organizationId);
    });

    return _this;
  }

  _createClass(GPostTypeArea, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var groupPost = this.props.groupPost;
      var postTypeTabs = [{
        title: 'Text',
        key: 'textPost'
      }, {
        title: 'Link',
        key: 'linkPost'
      }, {
        title: 'Image',
        key: 'imagePost'
      }, {
        title: 'Video',
        key: 'videoPost'
      }];
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        selected: groupPost.postType,
        items: postTypeTabs,
        onChange: this.handlePostTypeChange
      }), groupPost.postType === 'linkPost' && /*#__PURE__*/React.createElement(GLinkPostSection, null), groupPost.postType === 'imagePost' && /*#__PURE__*/React.createElement(GImagePostSection, null), groupPost.postType === 'videoPost' && /*#__PURE__*/React.createElement(GVideoPostSection, null));
    }
  }]);

  return GPostTypeArea;
}(Component)) || _class);
export { GPostTypeArea as default };